<!-- Page Header Start-->
<div class="page-header" [class.close_icon]="navServices.collapseSidebar">
  <div class="header-wrapper row m-0">
    <!-- <shared-header-search></shared-header-search> -->
    <div class="header-logo-wrapper col-auto p-0">
      <div class="logo-wrapper">
        <a routerLink="/">
          <img
            class="img-fluid for-light"
            src="assets/images/logo/logo.png"
            alt=""
          />
          <img
            class="img-fluid for-dark"
            src="assets/images/logo/logo_dark.png"
            alt=""
          />
        </a>
      </div>
      <div class="toggle-sidebar" (click)="sidebarToggle()">
        <shared-feather-icons
          [icon]="'align-center'"
          class="status_toggle middle"
        ></shared-feather-icons>
      </div>
    </div>
    <!-- <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
      <shared-header-swiper></shared-header-swiper>
    </div> -->
    <div class="nav-right col pull-right right-header p-0 ms-auto">
      <!-- class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto" -->
      <ul class="nav-menus">
        @if (userType === USER_TYPES.ADMIN || userType === USER_TYPES.AGENT ||
        userType === USER_TYPES.COLLABORATOR_AGENT || userType ===
        USER_TYPES.COLLABORATOR_OPERATOR ) {

        <li class="d-none d-md-block" *appShowWithPermission="PERMITTED_VIEWS.MESSAGE_PLAYERS_WITH_AGENT">
          <shared-header-message-box
            (messageCountChange)="onMessageCountChange($event)"
          ></shared-header-message-box>
        </li>
        }

        <li class="language-nav d-none d-md-block" (click)="languageToggle()">
          <shared-header-languages></shared-header-languages>
        </li>
        <!-- <li>
          <span class="header-search" (click)="searchToggle()">
            <svg>
              <use href="assets/svg/icon-sprite.svg#search"></use>
            </svg>
          </span>
        </li> -->
        <li class="d-none d-md-block">
          <div class="mode" (click)="layoutToggle()">
            <svg>
              <use href="assets/svg/icon-sprite.svg#moon"></use>
            </svg>
          </div>
        </li>
        <li
          class="onhover-dropdown mt-1"
          *appShowWithPermission="PERMITTED_VIEWS.BTN_TRANSFER_NAV"
        >
          <transfer-selector></transfer-selector>
        </li>
        <li
          class="onhover-dropdown"
          *appShowWithPermission="PERMITTED_VIEWS.BTN_ADD_USER_NAV"
        >
          <app-user-type-selector></app-user-type-selector>
        </li>
        <!--  <li class="onhover-dropdown">
          <shared-header-bookmark></shared-header-bookmark>
        </li> -->
        <li>
          <app-balance-user-cards></app-balance-user-cards>
        </li>
        <!--   <li class="cart-nav onhover-dropdown">
          <shared-header-cart></shared-header-cart>
        </li>
        <li class="onhover-dropdown">
          <shared-header-notification></shared-header-notification>
        </li> -->
        <li class="profile-nav onhover-dropdown p-0">
          <shared-header-my-account
            [messageCount]="messageCount"
          ></shared-header-my-account>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- Page Header Ends -->
